import "./ViewChampionship.scss";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import Button from "../../../Components/Button/Button";
import { DataGrid } from "@mui/x-data-grid";
import MessageModal from "../../../Components/Modals/MessageModal/MessageModal";
import { useState, useEffect } from "react";
import { ViewChampionshipColumns } from "../../../SourceData";
import newRequest from "../../../Utils/newRequest";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

const ViewChampionship = () => {
  const { id } = useParams(); // Get championship ID from URL params

  const isMobile = useMediaQuery("(max-width:767px)");
  const [openMessage, setOpenMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("all");
  const [championshipData, setChampionshipData] = useState(null);

  // Function to fetch championship data with pagination and level filter
  const fetchChampionshipData = async (page, pageSize) => {
    setLoading(true);
    try {
      // Prepare the API endpoint with parameters
      let endpoint = `/showChampionshipWithSubscribers/${id}?subscriber_page=${
        page + 1
      }&subscriber_number=${pageSize}`;

      // Add level_id parameter if a specific level is selected
      if (selectedLevel !== "all") {
        endpoint += `&level_id=${selectedLevel}`;
      }

      const response = await newRequest.get(endpoint);
      const data = response.data.data.championship;

      // Store the complete championship data
      setChampionshipData(data);

      // Extract levels data
      if (data.levels && data.levels.length > 0) {
        setLevels(data.levels);
      }

      // Set rows from API response
      if (data.subscribers_paginated && data.subscribers_paginated.data) {
        setRows(data.subscribers_paginated.data);
        setTotalRows(data.subscribers_paginated.meta.total);
      } else if (data.winners_subscribers) {
        // Fallback to winners_subscribers if paginated data is not available
        setRows(data.winners_subscribers);
        setTotalRows(data.winners_subscribers.length);
      }
    } catch (error) {
      console.error("Error fetching championship data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch and refetch when filters or id changes
  useEffect(() => {
    if (id) {
      fetchChampionshipData(paginationModel.page, paginationModel.pageSize);
    }
  }, [id, selectedLevel]);

  // Handle pagination change
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
    fetchChampionshipData(newPaginationModel.page, newPaginationModel.pageSize);
  };

  // Handle checkbox selection
  const handleSelectionModelChange = (newSelectionModel) => {
    setSelectedRows(newSelectionModel);
  };

  // Handle level selection change
  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
    // Reset pagination when filter changes
    setPaginationModel({
      ...paginationModel,
      page: 0,
    });
  };

  return (
    <div className="edit">
      <div className="container">
        <h3>عرض البطولة</h3>
        <div className="header">
          {/* Level Select */}
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="level-select-label">المستوى</InputLabel>
            <Select
              labelId="level-select-label"
              id="level-select"
              value={selectedLevel}
              onChange={handleLevelChange}
              label="المستوى"
              dir="rtl"
            >
              <MenuItem value="all">الجميع</MenuItem>
              {levels.map((level) => (
                <MenuItem key={level.id} value={level.id}>
                  {level.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <div
              onClick={() => {
                if (selectedRows.length > 0) {
                  setOpenMessage(true);
                }
              }}
              style={{ width: isMobile ? "100%" : "" }}
            >
              <Button
                text={`حذف متعدد ${
                  selectedRows.length > 0 ? `(${selectedRows.length})` : ""
                }`}
                variant="outlined"
                size={isMobile ? "full" : "small"}
                disabled={selectedRows.length === 0}
              />
            </div>
          </div>
        </div>
        <div className="data-grid">
          <DataGrid
            autoHeight
            columns={ViewChampionshipColumns}
            rows={rows.map((row, index) => {
              return {
                ...row,
                id: row.id || index, // Ensure each row has a unique id
                index:
                  paginationModel.page * paginationModel.pageSize + index + 1,
              };
            })}
            disableDensitySelector
            checkboxSelection
            disableRowSelectionOnClick
            loading={loading}
            paginationMode="server"
            rowCount={totalRows}
            pageSizeOptions={[10, 25, 50]}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            onRowSelectionModelChange={handleSelectionModelChange}
          />
        </div>
      </div>
      {/* Message Modal */}
      <MessageModal
        message="هل انت متاكد من حذف هذه العناصر؟"
        extraMessage={`تم اختيار ${selectedRows.length} عنصر للحذف`}
        open={openMessage}
        onClose={() => setOpenMessage(false)}
        onConfirm={() => {
          // Implement delete functionality here
          console.log("Deleting items:", selectedRows);
          setOpenMessage(false);
          setSelectedRows([]);
        }}
      />
    </div>
  );
};

export default ViewChampionship;
